import mixins from 'vue-typed-mixins';

import StudyMixin from '@/user/mixins/StudyMixin';



export default mixins(StudyMixin).extend({

  name: 'RestErrorBar',



});
